module.exports = __webpack_public_path__ + "img/item6-5.e317459d.jpg";